<template>
    <div class="tag" :class="{ tagSelected: isSelected}" v-on:click="onTagClicked">{{tag.name}}</div>
</template>

<script>
export default {
    name: "Tag",
    props: {
        tag: {},
        isSelected: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onTagClicked() {
            this.$emit('onClicked');
        }
    }
}
</script>

<style scoped>
    .tag, .tagSelected {
        font-size: 20px;
        border: 1px solid black;
        border-radius: 30px;
        padding: 5px 20px 5px 20px;
        margin-right: 10px;
        margin-bottom: 10px;
    }

    .tag:hover {
        cursor: pointer;
        color: white;
        background-color: black;
    }

    .tagSelected {
        color: white;
        background-color: black;
    }

    /*.tagSelected:hover {
        cursor: pointer;
        color: black;
        background-color: white;
    }*/
</style>